import { UserAuthWrapper } from 'redux-auth-wrapper';
import { homeRouteSelector } from 'common/features/selectors';
import {
    loadingMeSelector,
} from 'common/permissions/selectors';
import {
    canEditUsersPredicate,
    canEditGroupsPredicate,
    dataSourcesPredicate,
    manageStudyPermissionsPredicate
} from 'common/permissions/predicates';

export const UserCanEditUsers = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: canEditUsersPredicate,
    FailureComponent: null
});

export const UserCanManageStudyPermissions = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyPermissionsPredicate,
    failureRedirectPath: (state) => homeRouteSelector(state)
});

export const UserCanEditGroups = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: canEditGroupsPredicate,
    FailureComponent: null
});


export const UserCanViewDataSources = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: dataSourcesPredicate,
    FailureComponent: null
});
